//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import VueGridDesigner          from '@/component';
import { library }              from '@fortawesome/fontawesome-svg-core';
import { faInfo, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon }      from '@fortawesome/vue-fontawesome';
import BsLayoutBuilder          from '@/demo/bs-layout-builder';
import BsTableBuilder           from '@/demo/bs-table-builder';

library.add ( faInfo );
library.add ( faPlusSquare );

export default {

    name      : 'App',
    components: { VueGridDesigner, FontAwesomeIcon, BsLayoutBuilder, BsTableBuilder },
    data () {
        return {

            grids: {

                basic: [
	                {
	                    blocks: [
		                    { span: 2},
		                    { span: 2}
	                    ]
	                }
                ],

                bones: [
                    {
                        blocks: [
                            { span: 1, content: '' },
                            { span: 1, content: '' },
                            { span: 1, content: '' },
                            { span: 1, content: '' }
                        ]
                    },
                    {
                        blocks: [
                            { span: 3, content: '' },
                            { span: 1, content: '' }
                        ]
                    },
                    {
                        blocks: [
                            { span: 2, content: '' },
                            { span: 2, content: '' }
                        ]
                    },
                    {
                        blocks: [
                            { span: 4, content: '' }
                        ]
                    }
                ],

                content: [
                    {
                        label : 'First row',
                        blocks: [
                            {
                                span   : 4,
                                source : 'https://www.blindtextgenerator.com/lorem-ipsum',
                                content: '<h5 class="mt-2">Far, far away</h5><p class="p-2">Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts. Separated they live in Bookmarksgrove right at the coast of the Semantics, a large language ocean. A small river named Duden flows by their place and supplies it with the necessary regelialia. It is a paradisematic country, in which roasted parts of sentences fly into your mouth. Even the all-powerful Pointing has no control about the blind texts it is an almost unorthographic life</p>'
                            }
                        ]
                    },
                    {
                        label : 'Second row',
                        blocks: [
                            {
                                span   : 2,
                                source : 'https://en.wikipedia.org/wiki/The_quick_brown_fox_jumps_over_the_lazy_dog',
                                content: '<h5 class="mt-2 ml-2 text-left">Quick ol\' foxy</h5><p class="text-left p-2">The quick, brown fox jumps over a lazy dog. DJs flock by when MTV ax quiz prog.</p>'
                            },
                            {
                                span   : 2,
                                source : 'via.placeholder.com',
                                content: '<div class="m-2"><img class="img-fluid rounded" src="https://via.placeholder.com/468x60?text=Image: 468x60" /></div>'
                            }
                        ]
                    }
                ],

                customStyle: [
                    {
                        blocks: [
                            { span: 2, content: 'One' },
                            { span: 2, content: 'Two' }
                        ]
                    }
                ],

                slots: [
                    {
                        blocks: [
                            { span: 2},
                            { span: 2}
                        ]
                    }
                ],

                events: [
                    {
                        blocks: [
                            { span: 2},
                            { span: 2}
                        ]
                    }
                ],

                html: [
                    {
                        isHeader: true,
                        blocks  : [
                            { span: 2, classes: 'text-center' },
                            { span: 2, classes: 'text-center' },
                            { span: 2, classes: 'text-center' },
                            { span: 2, classes: 'text-center' },
                            { span: 2, classes: 'text-center' },
                            { span: 2, classes: 'text-center' }
                        ]
                    },
                    {
                        blocks: [
                            { span: 3, classes: 'text-center' },
                            { span: 3, classes: 'text-center' },
                            { span: 3, classes: 'text-center' },
                            { span: 3, classes: 'text-center' }
                        ]
                    },
                    {
                        isFooter: true,
                        classes : 'text-center',
                        blocks  : [
                            { span: 12, classes: 'text-center' }
                        ]
                    }
                ]

            },

            controls: {
                basic      : {
                    mode          : 'edit',
                    blocksPerRow  : 4,
                    maxRows       : 0,
                    minBlockHeight: 100
                },
                bones      : {
                    mode: 'edit'
                },
                content    : {
                    mode: 'view'
                },
                customStyle: {
                    mode      : 'edit',
                    rowClass  : 'demo__row',
                    blockClass: 'demo__block'
                },
                slots      : {
                    mode: 'edit'
                },
                events     : {
                    mode: 'edit'
                },
                html       : {
                    mode          : 'edit',
                    blocksPerRow  : 12,
                    maxRows       : 4,
                    minBlockHeight: 70
                }
            }

        };
    },
    computed  : {},
    methods   : {

        getJSON ( data ) {
            return JSON.stringify ( data, null, 4 );
        },

        getCode ( which ) {
            switch ( which ) {

                case 'basicStyleMarkup':
                    return '<vue-grid-designer v-model="grids.basic" />';

                case 'contentStyleMarkup':
                    return `<vue-grid-designer
    v-model="grids.content"
    :on-new-row="getNewContentRow"
    :on-new-block="getNewContentBlock"
>`;

                case 'customStyleMarkup':
                    return `<vue-grid-designer
    v-model="grids.customStyle"
    mode="edit"
    row-class="demo__row"
    block-class="demo__block"
/>`;

                case 'customStyleScss':
                    return `#demo {

    .vgd__row.demo__row {
        padding: 1rem;
        background-color: black;

        .vgd__row__toolbar {
            background-color: rgba(0, 0, 0, .5);
            &__button {
                color: white;
            }
        }
    }

    .vgd__block.demo__block {
        padding: .6rem;
        background-color: rgba(255, 127, 80, .5);
    }

    .use-hover {
        &.vgd__row.demo__row {
            &:hover,
            &:hover:after {
                background-color: rgba(0, 0, 0, .5);
            }
            .vgd__block.demo__block:hover {
                background-color: rgb(255, 127, 80);
            }
        }
    }

};`;

                case 'slotsMarkup':
                    return `<vue-grid-designer
    v-model="grids.slots"
    mode="edit"
>

    <template v-slot:footer="blockScope">
        <button
            class="btn btn-block btn-primary"
            @click="blockScope.addRow"
            :disabled="blockScope.maxRows > 0 && grids.slots.length >= blockScope.maxRows"
        >
            <font-awesome-icon :icon="['fas', 'plus-square']" size="2x" class="mr-3"/>
            <span style="font-size: 2rem;">Create Row</span>
        </button>
    </template>

</vue-grid-designer>`;

                case 'eventsMarkup':
                    return `<vue-grid-designer
    v-model="grids.events"
    mode="edit"
    @ready="showDemoEvent('ready', $event)"
    @update="showDemoEvent('update', $event)"
    @remove-block="showDemoEvent('remove-block', $event)"
    @remove-row="showDemoEvent('remove-row', $event)"
    @add-block="showDemoEvent('add-block', $event)"
    @add-row="showDemoEvent('add-row', $event)"
    @drag-start="showDemoEvent('drag-start', $event)"
    @drag-stop="showDemoEvent('drag-stop', $event)"
    @block-changed="showDemoEvent('block-changed', $event)"
    @input="showDemoEvent('input (manual handler)', $event)"
/>`;

                case 'htmlLayout':
                    return `<bs-layout-builder
    v-model="grids.html"
    :layout-size="controls.html.blocksPerRow"
    class="border rounded shadow-sm p-2"
/>`;

                case 'htmlTable':
                    return `<bs-table-builder
    v-model="grids.html"
    :layout-size="controls.html.blocksPerRow"
    class="border rounded shadow-sm p-2"
/>`;

                case 'htmlMarkup':
                    return `<vue-grid-designer
    v-model="grids.html"
    mode="edit"
    :blocks-per-row="12"
    :max-rows="4"
    :min-block-height="70"
/>`;

            }
        },

        showDemoEvent ( name, e ) {
            console.log ( `Event: ${ name }`, e );
        },

        async getNewContentRow () {

            return {
                label : `Row ${ this.grids.content.length }`,
                blocks: [
                    await this.getNewContentBlock ()
                ]
            };

        },

        async getNewContentBlock ( row, span ) {

            return {
                span   : span || 4,
                source : 'https://www.lipsum.com/',
                content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
            };

        }

    }

};
